var chunkMapping = {
	"8517": [
		308517
	],
	"16666": [
		29529
	],
	"19252": [
		619252
	],
	"22815": [
		322815
	],
	"29529": [
		29529
	],
	"32148": [
		569069
	],
	"41528": [
		551977,
		101614
	],
	"43039": [
		404657,
		894713,
		227054,
		836534
	],
	"43944": [
		543944
	],
	"54871": [
		654871
	],
	"67624": [
		564011,
		956443
	],
	"69069": [
		569069
	],
	"70783": [
		818768,
		545819,
		39077,
		694249,
		954457,
		895332
	],
	"71132": [
		971132
	],
	"73165": [
		873165
	],
	"75619": [
		475619
	],
	"95919": [
		895919
	],
	"99648": [
		899648
	]
};
var idToExternalAndNameMapping = {
	"29529": [
		"default",
		"./components/TeachingCard",
		778665
	],
	"39077": [
		"default",
		"./components/GradingRubric",
		778665
	],
	"101614": [
		"default",
		"./components/Presentation",
		778665
	],
	"227054": [
		"default",
		"./utils/html-doc",
		778665
	],
	"308517": [
		"default",
		"./components/Icon/FocusIcon",
		778665
	],
	"322815": [
		"default",
		"./components/HelpCenter",
		778665
	],
	"404657": [
		"default",
		"./components/HtmlWithPinyin",
		778665
	],
	"475619": [
		"default",
		"./components/Question",
		778665
	],
	"543944": [
		"default",
		"./components/UserProfileAvatar",
		778665
	],
	"545819": [
		"default",
		"./components/FullscreenContainer",
		778665
	],
	"551977": [
		"default",
		"./components/NewFlashcard",
		778665
	],
	"564011": [
		"default",
		"./components/Game",
		778665
	],
	"569069": [
		"default",
		"./components/CoreItemsIWGT",
		778665
	],
	"619252": [
		"default",
		"./hooks/dictionary",
		778665
	],
	"654871": [
		"default",
		"./components/UserAvatar",
		778665
	],
	"694249": [
		"default",
		"./components/WritingFeedback/FeedbackSection",
		778665
	],
	"818768": [
		"default",
		"./components/EvaluationForm",
		778665
	],
	"836534": [
		"default",
		"./utils/pinyin",
		778665
	],
	"873165": [
		"default",
		"./avatar/constants",
		778665
	],
	"894713": [
		"default",
		"./hooks/use-resize",
		778665
	],
	"895332": [
		"default",
		"./components/WritingFeedback/hooks/use-writing-feedback",
		778665
	],
	"895919": [
		"default",
		"./components/Quiz",
		778665
	],
	"899648": [
		"default",
		"./components/AudioPlayer",
		778665
	],
	"954457": [
		"default",
		"./components/WritingFeedback/WritingQuestionSection",
		778665
	],
	"956443": [
		"default",
		"./utils/route-change-prompt",
		778665
	],
	"971132": [
		"default",
		"./components/Playbook",
		778665
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_modules__[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}